import { useDialogState } from "../../../hooks/useDialogState";
import { ResponsiveDialog } from "components/modal";
import { useWatch } from "react-hook-form";
import { AddAthleteButton } from "./AddAthleteButton";
import { SelectAthleteDialog } from "./SelectAthleteDialog";

export const AthleteSelector = ({ control, checkAthleteSelectorShouldOpen, Dialog = SelectAthleteDialog, dialogId = "athlete-selector-dialog-title", isSeriesRegistration, ...rest }) => {
    const formAthletes = useWatch({ name: "athletes", control });

    const [dialogOpen, openDialog, closeDialog] = useDialogState();

    const onOpenDialog = () => checkAthleteSelectorShouldOpen().then(validated => validated && openDialog());

    return (
        <>
            <AddAthleteButton numberOfAthletes={formAthletes.length} onClick={onOpenDialog} isSeriesRegistration={isSeriesRegistration} />
            <ResponsiveDialog
                open={dialogOpen}
                onClose={closeDialog}
                className="lh-dialog"
                fullWidth
                maxWidth="sm"
                aria-labelledby={dialogId}
            >
                <Dialog
                    dialogId={dialogId}
                    control={control}
                    closeDialog={closeDialog}
                    formAthletes={formAthletes}
                    {...rest}
                />
            </ResponsiveDialog>
        </>
    );
};
